{
  "accountPage": {
    "header": {
      "accountTypes": "Tipos de conta",
      "newUsersSetup": "Novos usuários serão adicionados como"
    },
    "types": {
      "general": "Geral",
      "admin": "Administrador",
      "restricted": "Restrito",
      "anonymous": "Anônimo"
    },
    "table": {
      "headers": {
        "accountType": "Tipo de Conta",
        "accessActivity": "Acesso à Atividade?",
        "accessSettings": "Acesso às Configurações?"
      },
      "columns": {
        "restrictedToActivitiesNote": "Limitado a Ativos e Grupos compartilhados",
        "generalToSettingsNote": "Limitado a Ativos e Pessoas"
      }
    },
    "info": {
      "header": "Tipos de conta explicados",
      "admin": "Ideal para proprietários de locais de trabalho, gerentes seniores e administradores de escritório.",
      "general": "Ideal para funcionários em tempo integral. (Nossa recomendação padrão.)",
      "restricted": "Ideal para visitantes conhecidos, fornecedores, trabalhadores em tempo parcial e contratados que requerem acesso parcial ou limitado.",
      "anonymous": "Para indivíduos que não se inscreveram no Gripp. Eles só podem enviar Relatórios, Notas ou Rotinas com base no que escaneiam."
    },
    "menu": {
      "accountPage": "Conta",
      "settingsPage": "Configurações",
      "workspaceSettingsPage": "Configurações do espaço de trabalho"
    },
    "workplaceTitle": "Gerenciamento e Dados do Local de Trabalho",
    "downloadData": "Baixar Dados",
    "dataExport": {
      "cancel": "Cancelar",
      "title": "Exportação de Dados",
      "download": "Baixar"
    }
  },
  "account": {
    "allWorkspaces": "Todos os Espaços de Trabalho",
    "create": {
      "button": "Adicionar Usuário",
      "form": {
        "email": "E-mail",
        "firstName": "Primeiro Nome",
        "lastName": "Sobrenome",
        "role": "Função"
      },
      "validation": {
        "emailRequired": "E-mail é obrigatório",
        "role": "Função é obrigatória",
        "validEmail": "Por favor, insira um e-mail válido"
      }
    },
    "filter": {
      "apply": "Aplicar",
      "columnSelection": "Colunas (máx. {{count}})",
      "columns": {
        "createdAt": "Data de Entrada",
        "createdDate": "Data de Entrada",
        "createdTime": "Hora de Entrada",
        "email": "E-mail",
        "groups": "Grupos",
        "jobTitle": "Cargo",
        "location": "Localização",
        "name": "Nome (obrigatório)",
        "phone": "Número de Telefone",
        "roles": "Tipo de Conta",
        "workspace": "Espaço de Trabalho"
      },
      "searchPlaceholder": "Pesquisar nome, número ou e-mail",
      "columnButton": "Colunas",
      "groupsButton": "Grupos",
      "accountTypesButton": "Tipos de Conta",
      "noAccountTypes": "Sem Tipos de Conta"
    },
    "groups": {
      "addPeopleTo": "Adicionar {{count}} pessoas a:",
      "addPersonTo": "Adicionar 1 pessoa a:"
    },
    "list": {
      "accountType": "Tipo de Conta",
      "added": "Data de Entrada",
      "createdDate": "Data de Entrada",
      "createdTime": "Hora de Entrada",
      "email": "E-mail",
      "groups": "Grupos",
      "jobTitle": "Cargo",
      "location": "Localização",
      "name": "Nome",
      "phone": "Número de Telefone",
      "workspace": "Espaço de Trabalho"
    },
    "topBar": {
      "peopleSelected": "{{count}} pessoas selecionadas",
      "personSelected": "1 pessoa selecionada"
    },
    "menu": {
      "confirmDelete": {
        "primaryButton": "Sim",
        "secondaryButton": "Cancelar",
        "title": "Tem certeza de que deseja remover {{accountName}}?"
      }
    }
  },
  "activity": {
    "filter": {
      "cancel": "Cancelar",
      "groups": "Grupos",
      "activityOptions": "Opções de Atividade",
      "activityTypes": "Tipos de Atividade",
      "options": "Opções",
      "types": "Tipos",
      "notes": "Notas",
      "pending": "Pendente",
      "reset": "Redefinir",
      "routines": "Rotinas",
      "searchPlaceholder": "Pesquisar títulos de atividade",
      "searchLabels": "Pesquisar etiquetas",
      "solved": "Resolvido",
      "title": "Filtros",
      "labels": "Etiquetas",
      "urgent": "Urgente",
      "date": "Data",
      "all": "Tudo",
      "day": "dia",
      "week": "semana",
      "month": "mês",
      "today": "Hoje",
      "thisWeek": "Últimos 7 dias",
      "thisMonth": "Últimos 30 dias",
      "custom": "Personalizado",
      "customDate": "Data Personalizada",
      "from": "De",
      "to": "Até",
      "mentions": "Menções",
      "scheduled": "Agendado",
      "default": "Padrão",
      "notScheduled": "Não agendado",
      "pinned": "Fixado",
      "everything": "Tudo",
      "onlyMentions": "Apenas menções",
      "onlyPinned": "Apenas fixados",
      "onlyScheduled": "Apenas agendados",
      "sort": "Ordenar",
      "viewResults": "Ver {{count}} resultados"
    },
    "search": {
      "title": "Pesquisar",
      "search": "Pesquisar",
      "recentSearches": "Pesquisas recentes"
    },
    "header": {
      "title": "Atividade",
      "view": "Ver",
      "viewAll": "Ver Tudo"
    },
    "list": {
      "youAreMentioned": "Você foi mencionado."
    },
    "menu": {
      "title": "Atividade",
      "titlePlural": "Atividades"
    },
    "textEmpty": "Sem atividade",
    "topBar": {
      "results": "resultados"
    },
    "sort": {
      "mostRecent": "Última atualização",
      "reminderDate": "Data de lembrete",
      "oldest": "Data de criação"
    },
    "tapScan": "Toque em \"+\" para escanear ativos ou códigos de convite.",
    "messageBubble": {
      "joinWorkspace": {
        "title": "Junte-se a um espaço de trabalho!",
        "description": "Você ainda não está em um espaço de trabalho.\nEscaneie um código de convite para se juntar a um\nespaço de trabalho!"
      },
      "addActivity": {
        "title": "Adicionar Atividade",
        "description": "Você ainda não tem nenhuma atividade.\nToque em '+' para adicionar um relatório ou nota sobre seu ativo e manter sua equipe informada."
      },
      "addAsset": {
        "title": "Adicionar Ativos",
        "description": "Você ainda não tem nenhum ativo.\nToque em '+' para escanear e adicionar seu primeiro ativo para começar."
      },
      "or": "ou",
      "newSub": "iniciar uma nova assinatura",
      "here": "aqui"
    }
  },
  "admin": {
    "menu": {
      "admin": "Pessoas",
      "workspaces": "Espaços de Trabalho"
    }
  },
  "alerts": {
    "addAnother": "Adicionar outro",
    "create": {
      "alertName": "Nome do Alerta",
      "asset(s)": "Ativo(s)",
      "assetSearchPlaceholder": "Pesquisar nome do ativo",
      "assets": "Ativos",
      "doNotAlert": "<0>(Opcional)</0><1>Não alertar entre:</1>",
      "groupSearchPlaceholder": "Pesquisar nome do grupo",
      "groups": "Grupos",
      "promptRoutine": "<0>(Opcional)</0><1>Selecione uma rotina</1><0>para solicitar com este alerta:</0>",
      "promptRoutinePlaceholder": "nenhuma rotina selecionada",
      "title": "Criar Alerta",
      "what": "1. Escolha o quê:",
      "when": "3. Escolha quando:",
      "why": "2. Escolha por quê:"
    },
    "setAlert": "Definir alerta",
    "createButton": "Criar Novo",
    "createNewAlert": "Criar um Novo Alerta",
    "createAlert": "Criar Alerta",
    "alert": "Alerta",
    "deleteAlert": "Excluir Alerta",
    "nextAlert": "Próximo Alerta: ",
    "lastAlert": "Último Alerta: ",
    "lastAlertNA": "N/D",
    "confirm": "Confirmar",
    "currently": "Atualmente: ",
    "abovePlaceholder": "acima",
    "belowPlaceholder": "abaixo",
    "editAlert": "Editar Alerta",
    "intervalValue": "Valor do intervalo",
    "newAlert": "Novo Alerta",
    "number": "Número",
    "minDropdownPlaceholder": "Quando estiver acima de  _____ ",
    "maxDropdownPlaceholder": "Quando estiver abaixo de  _____ ",
    "setAlertLogic": "Definir Lógica de Alerta",
    "setAlertLogicPlaceholder": "Selecione uma lógica de alerta",
    "optionalSettings": "Configurações Opcionais",
    "customLabelTitle": "Personalizar título do alerta",
    "blackoutDates": "Datas de bloqueio?",
    "startDate": "Data de Início",
    "starting": "Começando",
    "day": "dia",
    "days": "dias",
    "togo": "restantes",
    "completions": "conclusões",
    "recorded": "registrado",
    "elapsed": "decorrido",
    "OR": "OU",
    "or": "ou",
    "on": "em",
    "skipped": "pulado",
    "every": "cada",
    "Every": "Cada",
    "startingValue": "Valor inicial",
    "onDate": "Em uma data específica",
    "onDays": "A cada ___ dias",
    "onDayInterval": "Lembrar-me após ___",
    "onDayIntervalUnit": "Intervalo",
    "dateInterval": {
      "minutes": "Minutos",
      "hours": "Horas",
      "days": "Dias",
      "weeks": "Semanas",
      "months": "Meses"
    },
    "onDaysSkipped": "A cada ___ dias a rotina está incompleta",
    "onRoutineCompletions": "A cada ___ vezes a rotina é concluída",
    "onInterval": "Com base em um intervalo",
    "selectRoutineToPrompt": "Selecionar Rotina para Solicitar",
    "selectAlertingLogic": "Selecionar Lógica de Alerta",
    "customLabelWhenAlertOccurs": "Etiqueta Personalizada Quando o Alerta Ocorrer",
    "selectRoutine": "Selecionar rotina",
    "reset": "Redefinir",
    "edit": {
      "alertName": "Nome do Alerta",
      "asset(s)": "Ativo(s)",
      "assets": "Ativos",
      "doNotAlert": "Não alertar entre",
      "groups": "Grupos",
      "none": "Nenhum",
      "promptRoutine": "<0>Selecione uma rotina</0><1>para solicitar com este alerta</1>",
      "promptRoutinePlaceholder": "nenhuma rotina selecionada",
      "setFor": "Este alerta está definido para",
      "setOn": "Configurar o alerta em",
      "title": "Editar Alerta",
      "when": "Quando"
    },
    "menu": {
      "confirmDelete": {
        "primaryButton": "Sim",
        "secondaryButton": "Cancelar",
        "title": "Tem certeza de que deseja excluir {{alertName}}?"
      },
      "delete": "Excluir",
      "disableAlert": "Desabilitar Alerta",
      "enableAlert": "Habilitar Alerta",
      "viewAlertActivities": "Ver Atividades de Alerta"
    },
    "new": {
      "header": "Alertas > Criar Alerta"
    },
    "title": "Automação",
    "trigger": {
      "counter": {
        "ceiling": "O contador ultrapassa",
        "daysSinceCompleted": "A rotina não foi concluída por",
        "daysSinceCompleted-end": "Dias",
        "every": "A cada",
        "every-end": "Dias",
        "floor": "O contador fica abaixo de",
        "onCompletionCount": "A rotina foi concluída a cada",
        "onCompletionCount-end": "Vezes",
        "onInterval": "O contador atinge o intervalo de"
      },
      "default": {
        "daysSinceCompleted": "A rotina não foi concluída por",
        "daysSinceCompleted-end": "Dias",
        "every": "A cada",
        "every-end": "Dias",
        "onCompletionCount": "A rotina foi concluída a cada",
        "onCompletionCount-end": "Vezes"
      }
    },
    "validation": {
      "alertTypeRequired": "Tipo de alerta obrigatório",
      "inputRequired": "Entrada obrigatória",
      "invalidDate": "Data inválida",
      "startDateRequiredForDays": "Data de início obrigatória para tipo de alerta Dias",
      "routineIdRequiredForInterval": "ID da rotina obrigatório para intervalo"
    },
    "setInterval": "Definir intervalo",
    "numberOfDays": "Número de dias",
    "numberOfTimes": "Número de vezes"
  },
  "asset": {
    "advancedAssetInformation": "Informações Avançadas do Ativo",
    "customAlert": {
      "tagAlreadyAdded": "Esta etiqueta já foi adicionada a este ativo.",
      "tryAnotherTag": "Esta etiqueta já está em uso e não pode ser selecionada, por favor, tente outra etiqueta."
    },
    "delete": {
      "button": "Excluir Ativo",
      "cancel": "Cancelar",
      "confirm": "Excluir",
      "title": "Tem certeza de que deseja excluir este ativo?"
    },
    "description": "Descrição",
    "descriptionPlaceholder": "Opcional",
    "details": "Detalhes",
    "detailsPlaceHolder": "Opcional",
    "editTitle": "Informações do Ativo",
    "groups": "Grupos",
    "groupsPlaceHolder": "(Opcional) Selecionar Grupo(s)",
    "groupsSearchPlaceHolder": "Pesquisar nome do grupo",
    "header": {
      "buttons": {
        "addNew": "Adicionar Relatório / Nota",
        "routines": "Rotinas",
        "addSomething": "Adicionar algo"
      },
      "recentActivity": "Atividade Recente"
    },
    "information": "Informações do Ativo",
    "mediaLibrary": "Biblioteca de Mídia",
    "name": "Nome",
    "namePlaceholder": "O que é isso?",
    "newIssue": "Algo novo?",
    "newTitle": "Configuração do Ativo",
    "tagCode": "ID Gripp",
    "assetPicture": "Tirar uma foto do ativo",
    "assetName": "Dê um nome a isso",
    "newAdditionalMedia": "Alguma foto adicional para enviar? (placas de dados, etiquetas do fabricante, etc.)",
    "secondaryDescription": "Alguma descrição secundária?",
    "optionalSetting": "Configurações Opcionais",
    "hideReportAndNoteOptionsAnonymous": "Ocultar opções de Relatório e Nota para visitantes anônimos",
    "files": {
      "title": "Arquivos",
      "noFiles": "Nenhum arquivo encontrado.",
      "addFilesLinks": "Adicionar arquivos / links",
      "save": "Salvar",
      "addFile": "Adicionar arquivo",
      "view": "Ver {{count}} resultado",
      "view_plural": "Ver {{count}} resultados",
      "camera": "Câmara"
    },
    "detail": {
      "edit": "Editar",
      "delete": "Excluir",
      "delete_asset": "Excluir Ativo",
      "delete_warning": "Esta ação não pode ser desfeita.",
      "confirmDelete": "Tem certeza de que deseja excluir o arquivo {{fileName}}?"
    },
    "productType": "Tipo de Produto",
    "serialNumber": "Número de Série",
    "addons": "Complementos ({{count}})",
    "addonsNoProduct": "Este ativo não tem tipo de produto. Atribua um produto para habilitar a seleção de complementos.",
    "enterTagCode": "Inserir Código da Etiqueta",
    "add": "Adicionar",
    "cancel": "Cancelar",
    "save": "Salvar",
    "tagCodePlaceholder": "Inserir código da etiqueta",
    "lookingUpTag": "Procurando etiqueta...",
    "pinnedActivity": "Atividade Fixada",
    "viewAll": "Ver Tudo"
  },
  "assets": {
    "filter": {
      "title": "Filtros",
      "search": "Pesquisar",
      "recentSearches": "Pesquisas recentes",
      "apply": "Aplicar",
      "reset": "Redefinir",
      "viewResults": "Ver {{count}} resultados",
      "columnButton": "Colunas",
      "columnSelection": "Colunas",
      "columns": {
        "createdAt": "Criado Em",
        "createdBy": "Criado Por",
        "description": "Descrição",
        "productName": "Nome do Produto",
        "groups": "Grupos",
        "lastAddress": "Localização",
        "lastScannedAt": "Última Digitalização",
        "lastUpdated": "Última Atualização",
        "name": "Nome (obrigatório)",
        "notes": "# de Notas",
        "alerts": "# de Alertas",
        "reports": "# de Relatórios Ativos",
        "routines": "# de Rotinas",
        "addons": "# de Complementos",
        "tagCode": "ID Gripp",
        "workspaces": "Espaço de Trabalho"
      },
      "groups": "Grupos",
      "groupsButton": "Grupos",
      "default": "Padrão",
      "searchPlaceholder": "Pesquisar nome, descrição, produto, add-ons ou ID Gripp",
      "filterToggle": "Filtragem combinada:"
    },
    "groups": {
      "addAssetTo": "Adicionar 1 ativo a:",
      "addAssetsTo": "Adicionar {{count}} ativos a:"
    },
    "list": {
      "createdAt": "Criado Em",
      "createdDate": "Data de Criação",
      "createdTime": "Hora de Criação",
      "createdBy": "Criado Por",
      "description": "Descrição",
      "productName": "Nome do Produto",
      "groups": "Grupos",
      "lastAddress": "Localização",
      "lastScannedAt": "Última Digitalização",
      "lastScannedDate": "Data da Última Digitalização",
      "lastScannedTime": "Hora da Última Digitalização",
      "lastUpdated": "Última Atualização",
      "lastUpdatedDate": "Data da Última Atualização",
      "lastUpdatedTime": "Hora da Última Atualização",
      "name": "Nome",
      "notes": "Notas",
      "alerts": "Alertas",
      "reports": "Relatórios Ativos",
      "routines": "Rotinas",
      "addons": "Complementos",
      "tagCode": "ID Gripp",
      "workspaces": "Espaço de Trabalho"
    },
    "menu": {
      "title": "Ativos",
      "titleSingular": "Ativo"
    },
    "textEmpty": "Sem ativos",
    "topBar": {
      "allAssets": "Todos os Ativos",
      "assetSelected": "1 ativo selecionado",
      "assetsSelected": "{{count}} ativos selecionados",
      "results": "{{count}} resultados"
    },
    "change": "Alterar",
    "routines": "Rotinas",
    "routineSearchPlaceholder": "Pesquisar nome da rotina",
    "addonsSearchPlaceholder": "Pesquisar nome do complemento"
  },
  "products": {
    "textEmpty": "Sem produtos",
    "list": {
      "name": "Nome"
    }
  },
  "avatar": {
    "menu": {
      "profile": "Perfil"
    }
  },
  "binaryCheck": {
    "button": "Atualizar",
    "instructions1": "Uma nova atualização está disponível!",
    "instructions2": "O Gripp pode não funcionar até então."
  },
  "camera": {
    "Cancel": "Cancelar",
    "grippInviteDetected": "Convite Gripp Detectado!",
    "grippTagDetected": "Etiqueta Gripp Detectada!",
    "noCameraAccess": "Sem acesso à câmera",
    "notGrippInvite": "Não é um Convite Gripp",
    "notGrippTagg": "Não é uma Etiqueta Gripp",
    "tryAgain": "Por Favor, Tente Novamente",
    "noPermissionModal": {
      "oopsMessage": "Ops! Você não tem permissão para\nacessar esta etiqueta Gripp. 🙈",
      "button": "Entendi!",
      "errorMessage": "Se você acredita que isso é um erro, confirme que\nvocê foi convidado para o local de trabalho correto ou\nentre em contato com o suporte do Gripp."
    }
  },
  "changesSaved": "Alterações Salvas",
  "common": {
    "back": "Voltar",
    "cancel": "Cancelar",
    "download": "Baixar",
    "reset": "Redefinir",
    "apply": "Aplicar",
    "save": "Salvar",
    "optional": "Opcional",
    "value": "Valor",
    "delete": "Excluir",
    "next": "Próximo",
    "remove": "Remover",
    "typeMessage": "Digite uma mensagem..."
  },
  "customAlert": {
    "ok": "OK"
  },
  "deleteAccount": {
    "button": "Excluir conta",
    "cannotUndone": "Esta ação não pode ser desfeita.",
    "confirm": "Confirmar Exclusão",
    "header": "Excluir Conta",
    "reasonInput": "Por favor, informe-nos quaisquer detalhes adicionais para excluir sua conta (opcional):",
    "reasonInputNoOptional": "Por favor, informe-nos quaisquer detalhes adicionais para excluir sua conta:",
    "submitted": "Sua solicitação de exclusão de conta foi enviada."
  },
  "dropdown": {
    "dropdownFooter": {
      "apply": "Aplicar",
      "reset": "Redefinir"
    }
  },
  "edit": "",
  "email": "E-mail",
  "features": {
    "title": "Recursos",
    "assignment": {
      "workspaces": "Espaços de trabalho",
      "accounts": "Contas",
      "workspaceSearchPlaceholder": "Pesquisar espaços de trabalho...",
      "accountSearchPlaceholder": "Pesquisar contas...",
      "noWorkspaces": "Nenhum espaço de trabalho encontrado",
      "noAccounts": "Nenhuma conta encontrada",
      "name": "Nome",
      "email": "Email",
      "phone": "Telefone"
    }
  },
  "firstName": "Primeiro Nome",
  "forbidden": "Proibido",
  "groups": {
    "groupsSelector": {
      "addToGroup": "Adicionar ao Grupo",
      "addtoNewGroup": "Adicionar ao Novo Grupo",
      "apply": "Aplicar",
      "clearGroups": "Limpar Grupos"
    },
    "searchGroups": "Pesquisar grupos",
    "noGroups": "Sem Grupos",
    "menu": {
      "title": "Grupos",
      "editGroup": "Editar Grupo"
    },
    "create": {
      "label": "Criar um Novo Grupo",
      "validation": {
        "name_required": "Nome do grupo é obrigatório"
      },
      "create": "Criar",
      "placeholder": "ex. Grupo de Tratores"
    },
    "list": {
      "name": "Nome do Grupo",
      "people": "Pessoas",
      "assets": "Ativos",
      "reports": "Relatórios Ativos",
      "routines": "Rotinas",
      "assetAlerts": "Alertas de Ativos",
      "groupAlerts": "Alertas de Grupo"
    },
    "common": {
      "textEmpty": "Sem grupo",
      "selectGroup": "Selecionar grupos",
      "searchGroup": "Pesquisar grupos",
      "createGroup": "Criar Grupo",
      "emptyStateMessage": "Crie um grupo digitando diretamente na barra de pesquisa."
    },
    "filter": {
      "searchPlaceholder": "Pesquisar nomes de grupos",
      "columnButton": "Colunas",
      "columns": {
        "name": "Nome do Grupo",
        "reports": "Relatórios Ativos",
        "assets": "Ativos",
        "people": "Pessoas",
        "routines": "Rotinas",
        "assetAlerts": "Alertas de Ativos",
        "groupAlerts": "Alertas de Grupo"
      },
      "columnSelection": "Colunas"
    },
    "assignments": {
      "name": "Nome",
      "jobTitle": "Cargo",
      "accountType": "Tipo de Conta",
      "assetSearchPlaceholder": "Pesquisar nome do ativo, descrição ou nome do grupo",
      "accountSearchPlaceholder": "Pesquisar nome ou cargo da pessoa",
      "routineSearchPlaceholder": "Pesquisar nome da rotina",
      "groupSearchPlaceholder": "Pesquisar nomes de grupos",
      "addonsSearchPlaceholder": "Pesquisar nome do complemento",
      "emptyAccountList": "Sem contas",
      "assets": "Ativos",
      "people": "Pessoas",
      "routines": "Rotinas"
    },
    "deleteGroup": {
      "deleteGroup": "Excluir Grupo",
      "alertBody1": "Tem certeza de que deseja excluir",
      "alertBody2": "Nota: ",
      "alertBody3": "Isso não excluirá nenhum ativo associado a este ",
      "alertBody4": "grupo.",
      "delete": "Excluir",
      "cancel": "Cancelar"
    }
  },
  "help": {
    "menu": {
      "title": "Ajuda"
    }
  },
  "alertsManagement": {
    "menu": {
      "title": "Alertas",
      "editAlert": "Editar alerta"
    },
    "filter": {
      "searchPlaceholder": "Pesquisar alertas...",
      "columnButton": "Colunas",
      "columnSelection": "Seleção de colunas",
      "columns": {
        "name": "Nome",
        "routineName": "Rotina",
        "assetName": "Ativo",
        "groupName": "Grupo",
        "productName": "Produto",
        "assetAlerts": "Alertas de Ativos",
        "lastAlertDate": "Último alerta",
        "nextAlertDate": "Próximo alerta",
        "createdAt": "Criado",
        "status": "Status"
      },
      "status": {
        "label": "Status",
        "all": "Todos",
        "enabled": "Ativado",
        "disabled": "Desativado"
      }
    },
    "common": {
      "textEmpty": "Nenhum alerta encontrado"
    },
    "list": {
      "name": "Nome",
      "routineName": "Rotina",
      "assetName": "Ativo",
      "groupName": "Grupo",
      "productName": "Produto",
      "assetAlerts": "Alertas de Ativos",
      "lastAlertDate": "Último alerta",
      "nextAlertDate": "Próximo alerta",
      "createdAt": "Criado",
      "status": "Status"
    },
    "deleteAlert": {
      "deleteAlert": "Excluir alerta",
      "alertBody1": "Tem certeza de que deseja excluir",
      "alertBody2": "Aviso:",
      "alertBody3": " Excluir este alerta o removerá permanentemente junto com todos os dados associados.",
      "delete": "Excluir",
      "cancel": "Cancelar"
    },
    "actions": {
      "enable": "Ativar",
      "disable": "Desativar",
      "enableSuccess": "{count} alerta(s) ativado(s) com sucesso",
      "disableSuccess": "{count} alerta(s) desativado(s) com sucesso"
    }
  },
  "invitation": {
    "initial": {
      "heading": "Você foi convidado para {{workspaceName}}!",
      "login": "Chave de Acesso",
      "step1": "Passo 1",
      "step1Instructions": "Baixe o aplicativo Gripp",
      "step2": "Passo 2",
      "step2Instructions": "Use esta chave para fazer login"
    },
    "invitePeople": {
      "copiedInvitationLink": "Link de convite copiado",
      "copyInviteLink": "Copiar link de convite",
      "errorCopyingInvitationLink": "Algo deu errado ao copiar o URL do convite",
      "invitePeopleForm": "Convidar pessoas por e-mail",
      "invitePeopleQR": "Convidar pessoas por código QR",
      "linkAllowsToJoinWorkplace": "Este link permite que qualquer pessoa solicite participar do seu local de trabalho.",
      "placeholder": "E-mails",
      "submit": "Enviar",
      "to": "Para"
    },
    "pending": {
      "accepted": "Siga o link enviado para seu e-mail para fazer login na sua Conta Gripp.",
      "cancel": "Cancelar",
      "join": "Participar",
      "joining": "Você está se juntando a {{workspaceName}}",
      "title": "Criar Perfil"
    },
    "qr": {
      "invitesYou": "convida você a participar",
      "showQr": "Mostrar QR para convidar outros"
    }
  },
  "issue": {
    "anonymous": {
      "addNote": "Adicionar Nota",
      "createReport": "Criar Relatório",
      "noteAdded": "Devidamente Anotado!",
      "noteAddedDownloadGrippApp": "Baixe o aplicativo Gripp para uma anotação ainda mais fácil!",
      "report": "Relatório",
      "reportAddedDownloadGrippApp": "Baixe o aplicativo Gripp para relatórios ainda mais rápidos!",
      "reported": "Problema Relatado!",
      "routineCompleted": "Boom, atualização confirmada!",
      "routineCompletedDownloadGrippApp": "Baixe o aplicativo Gripp para a melhor experiência!"
    },
    "common": {
      "addPicture": "Fotos",
      "description": "Descrição",
      "followUp": "Acompanhamento necessário?",
      "note": "Não, apenas anotando para referência",
      "report": "Sim, acompanhamento necessário",
      "addLabel": "Adicionar uma Etiqueta",
      "labelSubtitle": "Para pesquisa e filtragem mais fáceis.",
      "selectLabel": "Selecionar uma etiqueta",
      "searchLabel": "Pesquisar uma etiqueta",
      "createLabel": "Criar etiqueta",
      "emptyStateMessage": "Crie uma etiqueta digitando diretamente na barra de pesquisa.",
      "labelsApplied": "Etiquetas aplicadas"
    },
    "delete": {
      "confirm": "Confirmar exclusão?"
    },
    "editModal": {
      "header": "Editar",
      "save": "Salvar",
      "reviseSubmission": "Revisar Envio"
    },
    "latestMessage": {
      "media": "[Mídia]"
    },
    "menu": {
      "delete": "Excluir",
      "edit": "Editar",
      "editRoutine": "Editar Rotina",
      "pinToAsset": "Fixar no Ativo",
      "print": "Imprimir",
      "reassign": "Reatribuir",
      "reminder": "Lembrete",
      "unpin": "Desafixar",
      "unpinToAsset": "Desafixar do Ativo"
    },
    "new": {
      "addIt": "Adicionar Relatório / Nota",
      "optionalPlaceholder": "Opcional",
      "placeholder": "O que você está vendo?",
      "submit": "Enviar",
      "title": "Título"
    },
    "quickReminder": {
      "header": "Definir Lembrete",
      "subheader": "Para agendar este relatório para uma data futura."
    },
    "adjustCreationDate": {
      "header": "Ajustar Data de Criação"
    },
    "createdDate": {
      "header": "Data de Criação"
    },
    "types": {
      "attention": "Atenção",
      "urgent": "Urgente",
      "blocker": "Bloqueador",
      "pending": "Pendente",
      "done": "Concluído",
      "solved": "Resolvido",
      "routines": "Rotinas",
      "note": "Nota",
      "campaign": "Campanha"
    },
    "advancedSettings": "Configurações Avançadas",
    "dateFormat": "MM/DD/AAAA",
    "reminderFor": "Lembrete para:",
    "reassign": {
      "instructions": "Para qual dos seguintes ativos você deseja reatribuir?",
      "placeholder": "Pesquisar nome do ativo",
      "saveLabel": "Salvar",
      "title": "Reatribuir"
    },
    "topBar": {
      "allReplies": "respostas"
    },
    "reminder": {
      "notesOptional": "Notas (Opcional)",
      "scheduled": "Lembrete Agendado"
    }
  },
  "job": "",
  "jobTitle": "Cargo",
  "lastName": "Sobrenome",
  "loading": "Carregando",
  "login": {
    "codeSentTo": "Um código de acesso foi enviado para",
    "email": "E-mail",
    "error": {
      "invalidCredentials": "Credenciais inválidas",
      "processError": "Houve um erro ao processar sua solicitação"
    },
    "login": "Entrar",
    "password": "Senha",
    "resendCode": "Reenviar código",
    "tabs": {
      "new": {},
      "returning": {
        "title": "Estou voltando"
      }
    },
    "tryAnotherMethod": "Tentar outro método",
    "withEmail": "Continuar com E-mail",
    "withPassword": "Tenho uma senha",
    "withPhone": "Continuar com Telefone",
    "continue": "Continuar",
    "skip": "Pular",
    "smsConfirmationMessage": "Enviaremos uma mensagem de texto para confirmar seu número. Pode levar alguns segundos.",
    "emailConfirmationMessage": "Enviaremos um código de verificação para confirmar seu e-mail. Pode levar alguns segundos.",
    "aboutYourself": "Conte-nos sobre você!",
    "existingAccount": "Já tem uma conta Gripp?"
  },
  "logout": "Sair",
  "errorBoundary": {
    "title": "Ops!",
    "message": "Ocorreu um erro inesperado.",
    "tryAgain": "Tentar novamente"
  },
  "mentions": {
    "unknownUser": "Usuário Desconhecido",
    "youAreMentioned": "Você foi mencionado"
  },
  "modalMessages": {
    "completed": "Concluído"
  },
  "or": "ou",
  "onboarding": {
    "shareInfo": "Compartilhe mais sobre você com o Gripp!",
    "industrial": "Campo Industrial",
    "source": "Como você soube do Gripp?",
    "agriculture": "Agricultura"
  },
  "people": {
    "menu": {
      "people": "Pessoas"
    }
  },
  "phone": "Número de telefone",
  "plusMenu": {
    "add-asset": "Adicionar Ativo",
    "invite": "Convidar",
    "no-tag": "Sem Etiqueta?",
    "note": "Nota",
    "report": "Relatório",
    "scan": "Escanear"
  },
  "preferences": {
    "language": {
      "languages": {
        "english": "Inglês",
        "spanish": "Espanhol",
        "russian": "Russo",
        "kazakh": "Cazaque",
        "afrikaans": "Africâner",
        "portuguese": "Português",
        "french": "Francês"
      },
      "language": "Idioma",
      "preferredLanguageTitle": "Idioma Preferido"
    },
    "menu": {
      "title": "Configurações"
    },
    "settings": {
      "notifications": "Notificações",
      "profile": "Perfil",
      "title": "Configurações",
      "workSpaces": "Espaços de trabalho",
      "workspace_settings": "Configurações dos espaços de trabalho"
    },
    "notifications": {
      "activityLabelNotificationsTitle": "Notificações por rótulos de atividade",
      "groupNotificationsTitle": "Notificações de Grupo",
      "issueReplies": "Mensagens",
      "notificationTitle": "Notificações",
      "schedule": {
        "accept": "Aceitar",
        "cancel": "Cancelar",
        "endTime": "Hora de término:",
        "everyDay": "Todos os Dias",
        "notSet": "Não definido",
        "notificationSchedule": "Agenda de Notificações",
        "set": "Definir",
        "startTime": "Hora de início:",
        "weekDays": "Dias da Semana"
      },
      "severities": {
        "blue": "Novas Rotinas",
        "purple": "Novas Notas",
        "red": "Novos Relatórios"
      }
    }
  },
  "profile": {
    "edit": {
      "menu": {
        "title": "Editar Perfil"
      },
      "impersonate": {
        "impersonate": "Personificar",
        "unimpersonate": "Cancelar Personificação"
      },
      "error": {
        "title": "Erro ao atualizar o perfil",
        "generic": "Algo deu errado ao salvar seu perfil. Por favor, tente novamente.",
        "duplicatedPhone": "Este número de telefone já está associado a outra conta."
      }
    },
    "admin": {
      "title": "Personificação",
      "workspace": "Espaço de Trabalho",
      "workspaceUsers": "Usuários do Espaço de Trabalho"
    }
  },
  "recent_activities": "Atividades Recentes",
  "reminders": {
    "deleteReminder": "Excluir Lembrete",
    "setNewReminder": "definir um novo lembrete para"
  },
  "requestRoutine": {
    "apply": "Aplicar",
    "header": "Rotina",
    "instruction": "Por favor, envie sua ideia de rotina:",
    "placeHolder": "O que devemos começar a fazer?"
  },
  "routines": {
    "admin": {
      "create": "Salvar",
      "instructions": "Instruções",
      "issuePrefix": "Prefixo do Problema",
      "reportOnException": "Relatar Exceção?",
      "routineButtonText": "Botão da Rotina",
      "title": "Título",
      "type": "Tipo",
      "oneTimeOnly": "Apenas uma vez",
      "autoPrompt": "Solicitar automaticamente ao abrir ativo",
      "update": "Atualizar",
      "addMedia": "Adicionar Mídia",
      "image": "Imagem",
      "link": "Link",
      "linkLabel": "Adicionar Link",
      "linkUrl": "URL do Link",
      "linkUrlPlaceholder": "Inserir URL (ex., https://example.com)",
      "invalidUrl": "URL inválida",
      "enableAutoPinning": "Ativar fixação automática",
      "autoAddLabel": "Adicionar automaticamente um rótulo"
    },
    "assign": "Atribuir Rotinas",
    "copyToWorkspace": {
      "save": "Copiar",
      "title": "Copiar para Espaço de Trabalho",
      "workspace": "Espaço de Trabalho"
    },
    "counter": {
      "admin": {
        "decimalPlaces": "Habilitar Decimais (Opcional)",
        "tallyCounter": "Contador de Contagem",
        "uom": "Unidade de Medida",
        "counterType": "Tipo de Contador"
      },
      "user": {
        "genericCounter": {
          "change": "Alterar:",
          "initialValue": "Valor Inicial:",
          "newValue": "Novo Valor:"
        },
        "tallyCounter": {
          "add": "+ Adicionar",
          "added": "Adicionado",
          "adding": "Adicionando:",
          "instructions": "",
          "newValue": "Novo Valor:",
          "oldValue": "Valor Antigo:",
          "placeholder": "Inserir número...",
          "remove": "- Remover",
          "removed": "Removido",
          "removing": "Removendo:"
        }
      },
      "counterTypes": {
        "SIMPLE": "Simples",
        "CUMULATIVE": "Cumulativo",
        "TALLY": "Contagem"
      }
    },
    "time": {
      "admin": {
        "time": "Tipo de tempo",
        "labelStartTime": "Hora de Início",
        "labelEndTime": "Hora de Término"
      },
      "timeTypes": {
        "START_END_TIMES": "Horas de início e término",
        "TIME_ONLY": "Apenas hora",
        "DATE_ONLY": "Apenas data"
      },
      "message": {
        "time": "Hora",
        "start": "Início",
        "end": "Término",
        "date": "Data"
      }
    },
    "createNew": "Criar uma Rotina",
    "edit": {
      "header": "Rotinas > Editar Rotina"
    },
    "editRoutines": {
      "editRoutinesButton": "Editar Rotinas",
      "label": "Etiqueta: ",
      "routineInWorkplace": "Todas as rotinas disponíveis no seu local de trabalho",
      "title": "Editar",
      "saveSuccess": "Rotinas atualizadas com sucesso",
      "saveError": "Falha ao salvar rotinas",
      "routineAdded": "A rotina {{title}} foi adicionada",
      "routineRemoved": "A rotina {{title}} foi removida",
      "routineReordered": "Rotinas reorganizadas com sucesso"
    },
    "exceptions": {
      "addDetails": "Por favor, adicione detalhes adicionais ou fotos do problema:",
      "exceptionsNoticed": "{{count}} exceção notada",
      "exceptionsNoticed_plural": "{{count}} exceções notadas",
      "reportCreated": "Um relatório foi criado",
      "viewRelatedReport": "Ver Relatório Relacionado",
      "viewRelatedRoutine": "Ver Rotina Relacionada"
    },
    "header": {
      "title": "Rotinas",
      "view": "Ver",
      "viewAll": "Ver Tudo"
    },
    "menu": {
      "copyToWorkspace": "Copiar para Espaço de Trabalho",
      "delete": {
        "cancel": "Cancelar",
        "confirm": "Sim",
        "item": "Excluir",
        "title": "Tem certeza de que deseja excluir esta rotina?"
      },
      "download": "Baixar",
      "editRoutine": "Editar Rotina",
      "export": "Exportar dados",
      "exporting": "Exportando..."
    },
    "message": {
      "messageTitle": "{{name}} concluiu a rotina:",
      "added": "adicionado",
      "removed": "removido",
      "originalValue": "Valor Original",
      "newValue": "Novo Valor",
      "messageTitleUpdated": "{{name}} fez a atualização"
    },
    "modalCancel": {
      "primary": "Sair sem salvar.",
      "secondary": "Cancelar",
      "title": "Antes de voltarmos,"
    },
    "draftModal": {
      "continueDraft": "Continuar rascunho.",
      "startNew": "Iniciar uma nova rotina.",
      "cancel": "Cancelar",
      "messageNoDraft": "Um rascunho foi salvo",
      "messageWithoutCreator": "Um rascunho foi salvo em {{date}}",
      "messageWithCreator": "Um rascunho foi salvo por: \n{{creator}} em {{date}}"
    },
    "new": {
      "chooseTypeButton": "Próximo Passo: Escolher Opções",
      "header": "Rotinas > Criar Rotina"
    },
    "quickConfirm": {
      "admin": {
        "addOption": "Adicionar opção",
        "options": "Opções"
      }
    },
    "requestButton": "+ Solicitar Rotina",
    "signature": {
      "clear": "Limpar",
      "done": "Concluído",
      "sign": "Assinar",
      "signature": "Assinatura",
      "submit": "Enviar"
    },
    "status": {
      "admin": {
        "addStatus": "Adicionar status",
        "statuses": "Status",
        "openEndedResponse": "Resposta Aberta",
        "otherStatus": "Outro _______"
      }
    },
    "submit": "Enviar",
    "resubmit": "Reenviar",
    "saveDraft": "Salvar como rascunho",
    "types": {
      "COUNTER": "Contador",
      "QUICK_CONFIRM": "Confirmação Rápida",
      "STATUS": "Status",
      "WORKFLOW": "Mini Formulário"
    },
    "update": "Atualizar",
    "workflow": {
      "admin": {
        "page": {
          "addQuestion": "Adicionar Pergunta",
          "duplicateQuestion": "Duplicar Pergunta",
          "instructions": "Instruções",
          "page": "Página {{page}}",
          "questionType": "Tipo de Pergunta"
        },
        "question": {
          "addOption": "Adicionar opção",
          "exception": {
            "HasResponse": "Tem Resposta",
            "MissingResponse": "Resposta Ausente",
            "Off": "Desligado",
            "label": "Tratamento de exceções:"
          },
          "instructions": "Instruções",
          "multiline": "Multilinha",
          "options": "Opções",
          "question": "Pergunta {{question}}"
        },
        "routine": {
          "label": "Rotina",
          "select": "Selecionar uma rotina"
        }
      },
      "execution": {
        "optional": "Opcional",
        "submit": "Enviar"
      },
      "questionTypes": {
        "CHECKBOX": "Múltipla Seleção",
        "COUNTER": "Contador",
        "MEDIA": "Mídia",
        "QUICK_CONFIRM": "Confirmação Rápida",
        "RADIO": "Seleção Única",
        "ROUTINE": "Rotina",
        "SIGNATURE": "Assinatura",
        "STATUS": "Status",
        "TEXT": "Texto",
        "TIME": "Hora",
        "LABEL": "Etiqueta"
      }
    },
    "textEmpty": "Sem rotinas",
    "addToGroups": "Adicionar a Grupos",
    "addToGroupsDescription": "Atribuir {{count}} rotinas selecionadas a grupos",
    "list": {
      "name": "Nome",
      "type": "Tipo",
      "groups": "Grupos"
    }
  },
  "saveChanges": "Salvar Alterações",
  "signOut": "Sair",
  "support": {
    "genericDescription": "Às vezes acontecem problemas, mas se você ver esta página novamente, por favor nos avise para que possamos corrigir!",
    "sendEmail": "Ou envie-me um e-mail em",
    "title": "Ops, cometemos um erro"
  },
  "tags": {
    "assetName": "Nome do Ativo",
    "batches": {
      "title": "Pedidos"
    },
    "status": "Status",
    "tagCode": "Número da Etiqueta",
    "title": "Etiquetas",
    "updatedAt": "Atualizado Em",
    "version": "Versão"
  },
  "textEmptyList": "Sem dados",
  "topNav": {
    "activities": "Atividade",
    "add": "Adicionar",
    "assetInfo": "Ver Ativo",
    "assets": "Ativos",
    "back": "Voltar",
    "backButton": {
      "cancel": "Continuar editando",
      "confirmBack": "Há alterações não salvas!",
      "ok": "Sair sem salvar"
    },
    "cancel": "Cancelar",
    "customAlert": {
      "cancel": "Cancelar",
      "deleteAccount": "Tem certeza de que deseja excluir sua conta?",
      "exit": "Sair sem salvar?",
      "signOut": "Tem certeza de que deseja sair?",
      "yes": "Sim",
      "saveProgress": "Guardar para mais tarde."
    },
    "edit": "Editar",
    "editAsset": "Informações do Ativo",
    "invite": "Convidar Pessoas",
    "moreAssetInfo": "Mais Informações do Ativo",
    "save": "Salvar",
    "myHistory": "Meu Histórico",
    "modify": "Modificar"
  },
  "translation": {
    "seeOriginal": "Ver Original",
    "seeTranslation": "Ver Tradução"
  },
  "versionCheck": {
    "description": "Atualizações disponíveis! Alguns recursos podem não funcionar até que você atualize o navegador.",
    "refreshButton": "Atualizar"
  },
  "offline": {
    "banner": {
      "title": "Você está offline"
    }
  },
  "workspace": {
    "filter": {
      "searchPlaceholder": "Pesquisar nome",
      "columnButton": "Colunas",
      "tierButton": "Assinatura",
      "columnSelection": "Colunas",
      "tierSelection": "Assinatura",
      "columns": {
        "name": "Nome",
        "owner": "Administrador",
        "type": "Tipo",
        "subscriptionTierId": "Assinatura",
        "assetsCount": "Ativos",
        "routinesCount": "Rotinas",
        "alerts": "Alertas",
        "peopleCount": "Pessoas",
        "activitiesCount": "Atividades",
        "groupsCount": "Grupos",
        "createdAt": "Criado Em",
        "createdDate": "Data de Criação",
        "createdTime": "Hora de Criação",
        "createdBy": "Criado Por",
        "lastScanned": "Última Digitalização",
        "lastScannedDate": "Data da Última Digitalização",
        "lastScannedTime": "Hora da Última Digitalização",
        "updatedAt": "Última Atualização",
        "updatedDate": "Data da Última Atualização",
        "updatedTime": "Hora da Última Atualização",
        "lastActivity": "Última Atividade",
        "lastActivityDate": "Data da Última Atividade",
        "lastActivityTime": "Hora da Última Atividade"
      }
    },
    "types": {
      "PRODUCER": "Produtor",
      "OEM": "OEM"
    },
    "create": {
      "addButton": "Enviar",
      "administratorEmail": "E-mail do Administrador",
      "administratorPhone": "Número de Telefone do Administrador",
      "administratorFirstName": "Primeiro Nome do Administrador",
      "administratorLastName": "Sobrenome do Administrador",
      "copyRoutines": "Copiar Rotinas",
      "title": "Criar Espaço de Trabalho",
      "validation": {
        "admin_email_required": "E-mail do administrador é obrigatório",
        "admin_first_name_required": "Primeiro nome do administrador é obrigatório",
        "admin_last_name_required": "Sobrenome do administrador é obrigatório",
        "name_required": "Nome do espaço de trabalho é obrigatório",
        "valid_emil": "O e-mail do administrador deve ser um endereço de e-mail válido"
      },
      "type": "Tipo",
      "workspaceName": "Nome do Espaço de Trabalho",
      "name": "Nome do Espaço de Trabalho"
    },
    "createButton": "Criar Espaço de Trabalho",
    "menu": {
      "editWorkspace": "Editar Espaço de Trabalho"
    },
    "deleteWorkspace": {
      "deleteWorkspace": "Excluir Espaço de Trabalho",
      "alertBody1": "Tem certeza de que deseja excluir",
      "alertBody2": "Nota: ",
      "alertBody3": "Isso não excluirá nenhum ativo associado a este ",
      "alertBody4": "espaço de trabalho.",
      "delete": "Excluir",
      "cancel": "Cancelar"
    },
    "list": {
      "name": "Nome",
      "owner": "Administrador",
      "type": "Tipo",
      "assetsCount": "Ativos",
      "routinesCount": "Rotinas",
      "alerts": "Alertas",
      "peopleCount": "Pessoas",
      "activitiesCount": "Atividades",
      "groupsCount": "Grupos",
      "createdAt": "Criado Em",
      "createdDate": "Data de Criação",
      "createdTime": "Hora de Criação",
      "createdBy": "Criado Por",
      "lastScanned": "Última Digitalização",
      "lastScannedDate": "Data da Última Digitalização",
      "lastScannedTime": "Hora da Última Digitalização",
      "updatedAt": "Última Atualização",
      "updatedDate": "Data da Última Atualização",
      "updatedTime": "Hora da Última Atualização",
      "lastActivity": "Última Atividade",
      "lastActivityDate": "Data da Última Atividade",
      "lastActivityTime": "Hora da Última Atividade"
    }
  },
  "permissions": {
    "backButton": "Voltar",
    "continueButton": "Continuar",
    "enableInSettings": "Você deve habilitar esta permissão no menu do sistema para continuar.",
    "openSetting": "Abrir Configurações",
    "welcome": {
      "title": "Bem-vindo ao Gripp!",
      "description1": "Para usar o Gripp, precisamos habilitar várias permissões.",
      "description2": "Vamos guiá-lo por cada uma para explicar por que precisamos dela.",
      "description3": "Todas as configurações podem ser ajustadas através das configurações do seu telefone a qualquer momento."
    },
    "location": {
      "initial": {
        "title": "Acesso à sua localização, para rastrear seus ativos.",
        "description1": "O Gripp usa a localização do seu telefone para atualizar a localização dos seus ativos quando você os escaneia.",
        "description2": "No mínimo, pedimos que você permita a localização ao usar o aplicativo."
      },
      "denied": {
        "title": "Acesso à localização, para rastrear seus ativos.",
        "description1": "A localização ajuda a manter o controle dos seus ativos."
      },
      "button": "Continuar"
    },
    "camera": {
      "initial": {
        "title": "Acesso à sua câmera, para capturar, enviar mensagens e relatar.",
        "description1": "Fazer anotações e relatar problemas geralmente requer que você tire uma foto do que vê, então habilitar o acesso à câmera é importante para tirar fotos!"
      },
      "denied": {
        "title": "Acesso à câmera, para capturar, enviar mensagens e relatar.",
        "description1": "O acesso à câmera permite capturar e relatar problemas facilmente!"
      },
      "button": "Continuar"
    },
    "gallery": {
      "initial": {
        "title": "Acesso à sua galeria de fotos, para enviar imagens.",
        "description1": "Semelhante à câmera, às vezes você já tem fotos que deseja enviar para o Gripp.",
        "description2": "O Gripp terá acesso apenas às fotos que você escolher no momento do envio."
      },
      "denied": {
        "title": "Acesso à galeria de fotos, para enviar imagens.",
        "description1": "O acesso à galeria permite enviar as fotos que você escolher."
      },
      "button": "Continuar"
    },
    "notification": {
      "initial": {
        "title": "Fique atualizado com notificações.",
        "description1": "Seja notificado quando um novo alerta, problema ou relatório chegar."
      },
      "denied": {
        "title": "Notificações, para se manter atualizado.",
        "description1": "Receba alertas, problemas e relatórios da equipe—sem mensagens de marketing."
      },
      "button": "Continuar"
    },
    "allSet": "Tudo pronto, vamos começar a usar o Gripp!"
  },
  "routine": {
    "list": {
      "name": "Nome",
      "type": "Tipo de Rotina",
      "groups": "Grupos",
      "routines": "Rotinas",
      "oldRoutines": "Rotinas Antigas",
      "asset": {
        "name": "Nome",
        "description": "Descrição",
        "groups": "Grupos"
      }
    },
    "filter": {
      "searchPlaceholder": "Pesquisar nome da rotina",
      "columnButton": "Colunas",
      "columnSelection": "Colunas",
      "columns": {
        "name": "Nome",
        "type": "Tipo de Rotina",
        "assetsCount": "Ativos",
        "addonsCount": "Complementos",
        "allAssetsCount": "Todos os Ativos",
        "submissionsCount": "Envios",
        "groups": "Grupos",
        "lastSubmitted": "Último Enviado",
        "updatedAt": "Última Edição",
        "createdAt": "Data de Criação"
      }
    },
    "rowHeader": {
      "routineSelected": "1 rotina selecionada",
      "routinesSelected": "{{count}} rotinas selecionadas"
    },
    "permittedRoles": {
      "label": "Funções Permitidas",
      "noRoles": "Nenhuma função disponível"
    }
  },
  "product": {
    "change": "Alterar",
    "list": {
      "products": "Produtos",
      "name": "Nome",
      "description": "Descrição",
      "assetsCount": "Ativos",
      "filesCount": "Arquivos",
      "addonsCount": "Complementos",
      "routines": "Rotinas",
      "alerts": "Alertas de Ativos",
      "productAlerts": "Alertas de Produtos",
      "createdAt": "Criado Em",
      "updatedAt": "Última Atualização"
    },
    "filter": {
      "searchPlaceholder": "Pesquisar nome do produto",
      "columnButton": "Colunas",
      "columns": {
        "name": "Nome",
        "description": "Descrição",
        "assetsCount": "Ativos",
        "filesCount": "Arquivos",
        "addonsCount": "Complementos",
        "routines": "Rotinas",
        "alerts": "Alertas de Ativos",
        "productAlerts": "Alertas de Produtos",
        "createdAt": "Criado Em",
        "updatedAt": "Última Atualização"
      },
      "columnSelection": "Colunas"
    },
    "create": {
      "label": "Criar um Novo Produto",
      "validation": {
        "name_required": "Nome do produto é obrigatório"
      },
      "cancel": "Cancelar",
      "create": "Criar",
      "placeholder": "ex. Produto 1"
    },
    "delete": {
      "button": "Excluir Produto",
      "cancel": "Cancelar",
      "confirm": "Sim",
      "title": "Tem certeza de que deseja excluir o produto {{productName}}?"
    },
    "detail": {
      "addon_options": "Opções de Complemento",
      "no_addon_options": "Não há opções de complemento para este produto.",
      "add_more": "Adicionar mais",
      "description": "Descrição",
      "details": "Detalhes",
      "files": {
        "placeholder": "Algum arquivo adicional para enviar? (placas de dados, etiquetas do fabricante, etc.)",
        "addFilesLinks": "Adicionar arquivos / links"
      },
      "save": "Salvar",
      "cancel": "Cancelar",
      "profile": "Perfil do Produto",
      "assets": "Ativos",
      "routines": "Rotinas",
      "noAvailableRoutines": "Nenhuma rotina disponível para adicionar",
      "edit": "Editar",
      "delete": "Excluir",
      "confirmDelete": "Tem certeza de que deseja excluir o produto {{fileName}}?"
    },
    "specifications": {
      "title": "Todas as Especificações",
      "upload": "Enviar Dados",
      "download": "Baixar",
      "add_more": "Adicionar mais",
      "label_placeholder": "Nome da especificação",
      "value_placeholder": "Valor",
      "delete_confirm": "Tem certeza de que deseja excluir esta especificação?",
      "upload_coming_soon": "Funcionalidade de envio CSV em breve",
      "download_coming_soon": "Funcionalidade de download CSV em breve",
      "upload_success": "Especificações enviadas com sucesso",
      "upload_error": "Falha ao enviar especificações. Por favor, tente novamente.",
      "download_error": "Falha ao baixar especificações. Por favor, tente novamente.",
      "download_title": "Baixar Especificações",
      "no_data_to_download": "Nenhuma especificação para baixar",
      "sharing_not_available": "Compartilhamento de arquivos não está disponível neste dispositivo"
    },
    "assignments": {
      "assets": "Ativos",
      "routines": "Rotinas",
      "files": "Arquivos",
      "addons": "Complementos",
      "searchPlaceholder": "Pesquisar nome",
      "assetSearchPlaceholder": "Pesquisar nome do ativo",
      "routineSearchPlaceholder": "Pesquisar nome da rotina",
      "fileSearchPlaceholder": "Pesquisar nome do arquivo",
      "addonSearchPlaceholder": "Pesquisar nome do complemento"
    }
  },
  "file": {
    "list": {
      "files": "Arquivos",
      "name": "Nome",
      "products": "Produtos",
      "assets": "Ativos",
      "addons": "Complementos",
      "categories": "Categorias",
      "lastUpdated": "Última Atualização",
      "createdAt": "Criado Em"
    },
    "filter": {
      "searchPlaceholder": "Pesquisar nome do arquivo",
      "columnButton": "Colunas",
      "categories": "Categorias",
      "searchCategories": "Pesquisar categorias",
      "deleteCategory": "Excluir Categoria",
      "deleteCategoryMessage": "Tem certeza de que deseja excluir \"{{categoryName}}\"? Isso removerá a categoria de {{fileCount}} arquivos.",
      "columns": {
        "name": "Nome",
        "productsCount": "Produtos",
        "assetsCount": "Ativos",
        "addonsCount": "Complementos",
        "categories": "Categorias",
        "updatedAt": "Última Atualização",
        "createdAt": "Criado Em"
      },
      "columnSelection": "Colunas"
    },
    "assignments": {
      "productsSearchPlaceholder": "Pesquisar nome do produto",
      "addonsSearchPlaceholder": "Pesquisar nome do complemento"
    },
    "create": {
      "label": "Adicionar Arquivo",
      "linkLabel": "Adicionar Link",
      "title": "Título",
      "linkUrl": "URL do Link",
      "category": "Categoria",
      "file": "Arquivo (apenas um arquivo)",
      "link": "Link (apenas um link)",
      "add": "Adicionar",
      "addLink": "Adicionar Link",
      "titlePlaceholder": "Inserir título do arquivo",
      "linkUrlPlaceholder": "Inserir URL (ex., https://example.com)",
      "categoryPlaceholder": "Selecionar categorias",
      "categorySearchPlaceholder": "Pesquisar categorias",
      "createCategory": "Criar Categoria",
      "selectCategory": "Selecionar categorias",
      "searchCategory": "Pesquisar categorias",
      "emptyStateMessage": "Crie uma categoria digitando diretamente na barra de pesquisa.",
      "clickToUpload": "Clique para enviar arquivo",
      "linkPlaceholder": "Inserir URL (ex., https://example.com)",
      "validation": {
        "title_required": "Título do arquivo é obrigatório",
        "category_required": "Pelo menos uma categoria é obrigatória",
        "link_required": "URL do link é obrigatória",
        "link_invalid": "Por favor, insira uma URL válida"
      },
      "uploadError": "Falha ao enviar arquivo. Por favor, tente novamente.",
      "linkError": "Falha ao criar link. Por favor, tente novamente."
    },
    "dropdown": {
      "createFile": "Criar Arquivo",
      "file": "Arquivo",
      "link": "Link"
    },
    "tabs": {
      "products": "Produtos",
      "addons": "Complementos"
    },
    "deleteFile": {
      "deleteFile": "Excluir Arquivo",
      "alertBody1": "Tem certeza de que deseja excluir",
      "delete": "Excluir",
      "cancel": "Cancelar"
    },
    "assets": {
      "title": "Ativos",
      "name": "Nome",
      "description": "Descrição",
      "lastScanned": "Última Digitalização",
      "lastAddress": "Último Endereço",
      "lastUpdated": "Última Atualização",
      "noAssets": "Nenhum ativo encontrado"
    }
  },
  "addOn": {
    "list": {
      "addOns": "Complementos",
      "name": "Nome",
      "product": "Produtos",
      "asset": "Ativos",
      "media": "Arquivos",
      "routines": "Rotinas",
      "createdAt": "Criado Em",
      "updatedAt": "Última Atualização",
      "addon": "Complemento"
    },
    "filter": {
      "searchPlaceholder": "Pesquisar nome do complemento",
      "columnButton": "Colunas",
      "columns": {
        "name": "Nome",
        "product": "Produtos",
        "asset": "Ativos",
        "media": "Arquivos",
        "routines": "Rotinas",
        "createdAt": "Criado Em",
        "updatedAt": "Última Atualização"
      },
      "columnSelection": "Colunas"
    },
    "create": {
      "label": "Criar Complemento",
      "validation": {
        "name_required": "Nome do complemento é obrigatório"
      },
      "cancel": "Cancelar",
      "create": "Criar",
      "placeholder": "ex. Complemento 1"
    },
    "assignment": {
      "productSearchPlaceholder": "Pesquisar nome do produto",
      "mediaSearchPlaceholder": "Pesquisar nome do arquivo",
      "routineSearchPlaceholder": "Pesquisar nome da rotina",
      "success": "Produtos atribuídos ao complemento com sucesso",
      "error": "Deve fornecer IDs de produtos"
    },
    "files": {
      "title": "Arquivos",
      "name": "Nome",
      "type": "Tipo",
      "extension": "Extensão",
      "textEmpty": "Nenhum arquivo encontrado",
      "addFilesLinks": "Adicionar arquivos / links",
      "save": "Salvar",
      "delete": "Excluir",
      "list": {
        "name": "Nome",
        "categories": "Categorias"
      }
    },
    "textEmpty": "Toque em '+ Criar Complemento' para adicionar seu primeiro complemento.",
    "edit": {
      "label": "Editar Complemento",
      "save": "Salvar"
    },
    "deleteAddon": "Excluir Complemento"
  },
  "labels": {
    "confirmTextLine1": "Tem certeza de que deseja excluir a etiqueta \"{{labelName}}\"?",
    "confirmTextLine2": "Isso removerá a etiqueta de {{activityCount}} atividades existentes.",
    "cancel": "Cancelar",
    "delete": "Excluir",
    "editLabels": "Editar Etiquetas",
    "labels": "Etiquetas",
    "yes": "Sim"
  },
  "categories": {
    "confirmTextLine1": "Tem certeza de que deseja excluir a categoria \"{{categoryName}}\"?",
    "confirmTextLine2": "Isso removerá a categoria de {{fileCount}} arquivos existentes.",
    "cancel": "Cancelar",
    "delete": "Excluir",
    "editCategories": "Editar Categorias",
    "categories": "Categorias",
    "yes": "Sim"
  }
}